import produce from "immer";
import React, { FC } from "react";
import { useDispatch, useSelector } from "react-redux";
import { uuid } from "uuidv4";
import { startEditElement } from "../../../actions/elementListAction";
import { startAddTab } from "../../../actions/tabListAction";
import { Element } from "../../../models/elementModel";
import {
  getMainTabsByElementId,
  getTabListbyElementId,
  getTabsByElementId,
} from "../../../selectors/tabListSelector";
import TabListProperties from "./tab/tabListProperties";
import './elementProprtiesPanal.scss';
import Switch from "react-switch";


export interface TabFormElementPropertiesProps {
  element: Element;
}

const TabFormElementProperties: FC<TabFormElementPropertiesProps> = ({
  element,
}) => {
  const dispatch = useDispatch();
  const tabList = useSelector(getMainTabsByElementId(element.id));
  const addNewTabOption = (isDropdown: boolean) => {
    dispatch(
      startAddTab({
        elementId: element.id,
        formId: element.formId,
        name: isDropdown? "Dropdown" :"Tab",
        properties: {},
        styles: {},
        isDropDownTab: isDropdown,
        isMain: true,
        pairedKey:isDropdown ? uuid() : '',
        tabGroupTitle: isDropdown ? "Dropdown Tab" : '',
      })
    );
  };
  return (
    <div key={`${element.id}`} className="container mt-3">
      <div className="form-group row">
        <label htmlFor="elementName" className="col-sm-4 col-form-label font-size-12 align-text-left">
          Name
        </label>
        <div className="col-sm-8">
          <input
            value={`${element.name}`}
            className="form-control theam-textbox items-align-left"
            onChange={(e) => {
              const newElement = produce(element, draft => { draft.name = e.target.value})
              dispatch(startEditElement(newElement));
            }}
            type="text"
            id="elementName"
          />
        </div>
      </div>
      <div className="form-group row">
        <label htmlFor="btn-outline" className="col-sm-4 col-form-label font-size-12 align-text-left">
          Display
        </label>
          <div className="col-sm-2 mt-1">
            <Switch
              checked={element.properties.display}
              onChange={() =>{
                const newElement = produce(element, draft => {
                  draft.properties.display = !draft.properties.display;
                })
                dispatch(startEditElement(newElement));
              }}
              onColor="#86d3ff"
              onHandleColor="#2693e6"
              handleDiameter={15}
              uncheckedIcon={false}
              checkedIcon={false}
              boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
              activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
              height={10}
              width={24}
              className="react-switch"
              id="btn-outline"
             />
          </div>
      </div>
      <div className="form-group row">
        <label
          htmlFor="img-alt"
          className="col-sm-4 col-form-label font-size-12 align-text-left"
        >
          Add New Tab
        </label>
        <div className="col-sm-2 text-align-justify d-flex">
          <button
            type="button"
            className="btn btn-dark-theam btn-sm font-size-12 items-align-left"
            onClick={ () => {addNewTabOption(false)}}
          >
            <span>Tab</span>
          </button>
          <button
            type="button"
            className="btn btn-dark-theam btn-sm font-size-12 items-align-left ml-2"
            onClick={ () => {addNewTabOption(true)}}
          >
            <span>Dropdown Tab</span>
          </button>
        </div>
      </div>
      {tabList.length > 0 && (
        <TabListProperties element={element} tabs={tabList} />
      )}
    </div>
  );
};

export default TabFormElementProperties;
